import Vue from 'vue';
import Vuex from 'vuex';
import VueSocketio from 'vue-socket.io-extended'; // https://github.com/MetinSeylan/Vue-Socket.io/issues/58
import socketio from '@/common/utils/socketio.connection';
import ApiPlugin from '@/common/store/plugins/apiPlugin';
import controllableSideEffects from '@/common/store/plugins/sideEffectsPlugin';
import { featureStorePlugin } from '@/common/utils/featuresPlugin';
import bus from '@/common/utils/eventBus';
import abilityPlugin from './plugins/ability';
import getters from './getters';
import { initialModules as modules } from './modules';
import { useNotificationsStore } from './pinia/notifications';

Vue.use(Vuex);

export const store = new Vuex.Store<RootState>({
  getters,
  modules,
  plugins: [
    ApiPlugin.install(),
    controllableSideEffects,
    abilityPlugin,
    featureStorePlugin(Vue)
  ],
  strict: process.env.NODE_ENV !== 'production',
});

Vue.use(VueSocketio, socketio, { store });

bus.on((data) => {
  setTimeout(() => {
    if (data?.task_id) {
      const notificationsStore = useNotificationsStore();
      notificationsStore.trackTask(data.task_id);
    }
  }, 0);
});

export default store;
